export function toCustomAuthHeader(scope: string, signature: string) {
  return {
    'upright-custom-auth-scope': scope,
    'upright-custom-auth-signature': signature,
  };
}

export function authScopeForProductSet(productSetId: number | string): string {
  /* Note: Do not change this without checking with biz team.
  There might be secret links already sent to company platform users
  */
  return `blanket-product-set:${productSetId}`;
}

export function authScopeForCompanyClientData(companyId: string): string {
  // Changing this will invalidate current company data links
  return `company-client-data:${companyId}`;
}
